import React from 'react';
import { useChartShare } from '../../hooks/useChartShare';

interface ChartShareButtonProps {
    targetRef: React.RefObject<HTMLDivElement | null>;
    fileName: string;
    className?: string;
    style?: React.CSSProperties;
}

const ChartShareButton: React.FC<ChartShareButtonProps> = ({
    targetRef,
    fileName,
    className = '',
    style = {}
}) => {
    const { captureAndShare } = useChartShare();

    const handleShare = () => {
        if (targetRef.current) {
            captureAndShare(targetRef.current, fileName);
        }
    };

    return (
        <button
            onClick={handleShare}
            className={`chart-share-button ${className}`}
            style={{
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                padding: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#6b7280',
                transition: 'color 0.2s',
                ...style
            }}
            title="Partager le graphique"
            onMouseEnter={(e) => (e.currentTarget.style.color = '#2563eb')}
            onMouseLeave={(e) => (e.currentTarget.style.color = '#6b7280')}
        >
            <i className="material-icons" style={{ fontSize: '20px' }}>share</i>
        </button>
    );
};

export default ChartShareButton;
